var _path, _path2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1234 50H7.87657C5.12929 50 2.62682 48.6044 1.18247 46.2667C-0.261874 43.9291 -0.390669 41.066 0.837979 38.608L17.9614 4.35134C19.3233 1.62668 21.9546 0 25 0C28.0454 0 30.6767 1.62668 32.0386 4.35134L49.162 38.608C50.3907 41.066 50.2619 43.929 48.8176 46.2667C47.3732 48.6044 44.8707 50 42.1234 50Z",
    fill: "#FFB27D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33C24.4477 33 24 32.5523 24 32L24 25L24 18C24 17.4477 24.4477 17 25 17C25.5523 17 26 17.4477 26 18L26 25L26 32C26 32.5523 25.5523 33 25 33Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 38,
    rx: 2,
    ry: 2,
    transform: "rotate(-180 25 38)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomplete);
export default __webpack_public_path__ + "static/media/incomplete.06f6d4d07b11e8fe0bd0c06a9867bf16.svg";
export { ForwardRef as ReactComponent };